import axios, { CancelTokenSource } from 'axios';
import { DropdownOption } from 'components/final-form/dropdownUtils';
import Select from 'components/final-form/Select';
import _ from 'lodash';
import React, { FunctionComponent, useState } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { searchDoctorsForInput } from 'services/doctorServices';
import { DoctorDto } from 'ts-types/api.types';

interface DoctorSearchProps extends FieldRenderProps {
  onDoctorChange: (doctor: DoctorDto | string | undefined) => void;
}

const DoctorAutocompleteImpl = (props: DoctorSearchProps) => {

  const cancelTokenSource: CancelTokenSource = axios.CancelToken.source();
  const [doctors, setDoctors] = useState([] as DoctorDto[]);

  const mapDoctorsData = (doctorsData: DoctorDto[]): DropdownOption[] => {

    return doctorsData.map((doctor: DoctorDto) => {
      const doctorFirstName = doctor.firstName !== null ? doctor.firstName : "";
      const doctorName = doctor.name !== null ? doctor.name : "";
      const doctorStreet = doctor.street !== null ? doctor.street : "";
      let dropdownOption = `${doctorFirstName} ${doctorName}`;
      // if (doctorStreet !== "") {
      //   dropdownOption = `${dropdownOption}, ${doctorStreet}`;
      // }
      return {
        key: doctor.id,
        text: `${dropdownOption}`,
        description: doctorStreet,
        value: doctor.id,
        predefinedOption: true
      }
    })
  };

  const searchDoctors = (searchQuery: string) => {
    return searchDoctorsForInput(searchQuery, cancelTokenSource, 75)
        .then(response => {

          setDoctors(response);

          const newDoctorOptions = [...mapDoctorsData(response)];

          return newDoctorOptions;
        })
        .catch(() => {
          setDoctors([]);
        });
  };

  // const onNewDoctorAddition = (newAddition: DropdownOption) => {
  //   const foundDoctors = doctorOptions.find(doc => doc.key == newAddition.key);
  //
  //   if (!foundDoctors) {
  //     newAddition.predefinedOption = false;
  //   }
  // }

  return <Select
      remoteSearchMethod={(searchQuery: string) => searchDoctors(searchQuery)}
      allowAdditions
      customOnChange={(value: string | number | undefined) => {
        let doc: DoctorDto | string | undefined = undefined;
        if (value !== undefined && (typeof value === "number")) {
          doc = doctors.find(doc => doc.id === value);
        } else if (typeof value === "string") {
          doc = value;
        }
        props.onDoctorChange && props.onDoctorChange(doc);
      }}
      // onNewAddition={onNewDoctorAddition}
      remoteSearch
      clearable
      {..._.omit(props, "onDoctorChange")}
  />;
}

export const DoctorSearchDropdown = (DoctorAutocompleteImpl as FunctionComponent<FieldRenderProps>);
